import React from 'react';
import styled from 'styled-components';

import Image2 from '../../../../containers/assets/onboarding-gameoverview-image2.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    font-weight: 500;
    color: #ed716d;
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

const GameOverviewStep2 = () => (
  <Wrapper>
    <Text1>Game Overview</Text1>
    <Text2>The Segments</Text2>
    <Text3>
      There are 2 customer segments and your students can serve 1 or both: <b>Smartphone</b> manufacturers
      care about high resolution so that customers can take the best selfies; <b>Automobile</b> manufacturers,
      however, emphasize safety.
    </Text3>
    <Image>
      <img src={Image2} alt="" />
    </Image>
  </Wrapper>
);

export default GameOverviewStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/game-overview/step2.js